var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('p',{on:{"click":_vm.showPolicyDialog}},[_vm._v("隱私權條款")]),_c('p',[_vm._v("統一編號：50902932")])]),_c('PolicyDialog',{attrs:{"policyVisible":_vm.policyVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }